module.exports = __webpack_public_path__ + "static/media/blog-optimized.3988f470.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/blog-optimized.jpg
// module id = 961
// module chunks = 0